import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00142d9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=00142d9c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00142d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00142d9c')) {
      api.createRecord('00142d9c', component.options)
    } else {
      api.reload('00142d9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00142d9c&scoped=true", function () {
      api.rerender('00142d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/alliance/account/index.vue"
export default component.exports